import 'css/src/components/common/ui/Select/FormatGroupLabel';

import React from 'react';
import type { GroupBase } from 'react-select';

import type { SelectOption } from './types';

/**
 * Component for group label headers
 */
export default function formatGroupLabel(data: GroupBase<SelectOption>) {
    return (
        <div className="custom-select-format-group-label">
            <span>{data.label}</span>
        </div>
    );
}
